import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import StepContainer from './StepContainer';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Button from 'components/buttons/Button';
import PriceField from 'components/CustomInputs/PriceField';

import FormValidationContent from 'constants/FormValidationContent';
import Preference from 'containers/Preference';
import { CircularProgress } from '@material-ui/core';
import { findFieldByFieldKey } from 'utils';
import Preapproval from 'containers/Preapproval';

const content = {
	en: {
		title: 'How much have you saved for down payment?',
		dpInfo: 'Minimum down payment is Rp5.000.000,-.',
		next: 'Next',
		previous: 'Previous',
		somethingWentWrong: 'Something went wrong. Please try again later.'
	},
	id: {
		title: 'Berapa jumlah uang muka yang telah Anda tabung?',
		dpInfo: 'Uang muka min. Rp5.000.000,-.',
		next: 'Lanjut',
		previous: 'Kembali',
		somethingWentWrong: 'Terjadi kesalahan. Silakan coba lagi nanti.'
	}
};

const propTypes = {
	showToast: PropTypes.func,
	toNextPage: PropTypes.func,
	toPrevPage: PropTypes.func,
	validationSchema: PropTypes.object
};

const DownPayment = props => {
	const { toNextPage, toPrevPage, validationSchema, showToast } = props;

	const { state: { languageCode } } = Preference.useContainer();
	const translation = languageCode === 'en' ? content.en : content.id;
	const validationTranslation = languageCode === 'en' ? FormValidationContent.en : FormValidationContent.id;

	const {
		state: {
			form, fields, fieldsUpsert
		},
		upsertFields,
		resetFieldsUpsert
	} = Preapproval.useContainer();

	const { register, handleSubmit, setValue, watch, errors, clearErrors } = useForm({
		resolver: yupResolver(validationSchema)
	});

	const downpayment = watch('downpayment');

	useEffect(() => {
		const downpayment = findFieldByFieldKey(fields, 'downpayment')?.fieldValue;
		register({ name: 'downpayment' });
		setValue('downpayment', downpayment);
	}, []);

	useEffect(() => {
		if (fieldsUpsert.success) {
			resetFieldsUpsert();
			toNextPage();
		} else if (fieldsUpsert.error) {
			resetFieldsUpsert();
			showToast(translation.somethingWentWrong);
		}
	}, [fieldsUpsert]);

	const onSubmit = data => {
		upsertFields(form.id, [{
			fieldKey: 'downpayment',
			fieldValue: String(data.downpayment)
		}]);
	};

	const handlePrev = () => {
		toPrevPage();
	};

	return (
		<div className="down-payment-preapproval">
			<div className="title">{translation.title}</div>
			<form onSubmit={handleSubmit(onSubmit)}>
				<PriceField
					decimalSeparator={false}
					error={errors.downpayment ? true : false}
					message={validationTranslation[errors.downpayment?.message] || translation.dpInfo}
					onValueChange={value => {
						setValue('downpayment', value.value);
						if (value.value) clearErrors('downpayment');
						else setValue('downpayment', undefined);
					}}
					thousandSeparator={'.'}
					value={downpayment}
				/>
				<div className="buttons">
					<Button onClick={handlePrev} type="button" variant="outlined">
						{translation.previous}
					</Button>
					<Button disabled={fieldsUpsert.loading || !downpayment || downpayment < 5000000}
						type="submit"
						variant="contained"
					>
						{fieldsUpsert.loading? (
							<CircularProgress />
						) : (
							translation.next
						)}
					</Button>
				</div>
			</form>
		</div>
	);
};

DownPayment.propTypes = propTypes;
export default StepContainer(DownPayment);
